import { type BuilderInfo } from "helpers/AppProvider.types";

import { routes } from "utilities/routes";

/**
 * The internal link to the Specifications area, or to one spec in it. With the SpecificationGroups flag
 * the Book View is retired, so every link goes to the List route; without it, links keep the Book View.
 * The Book routes also redirect to List when the flag is on, so this only skips that hop.
 */
export function getSpecificationLink(
    builderInfo: BuilderInfo | null | undefined,
    externalId?: string,
): string {
    return builderInfo?.flags.specificationGroups === true
        ? routes.specification.getListLink(externalId)
        : routes.specification.getBookLink(externalId);
}
